import { AxiosResponse } from 'axios';
import FileSaver from 'file-saver';

export function handleSaveFile(response: AxiosResponse) {
    try {
        const disposition = response.headers['content-disposition'];
        const dispositionStr = typeof disposition === 'string' ? disposition : '';
        const filename = decodeURI(dispositionStr.split('filename=')[1].split(';')[0]).replaceAll('"', '');
        const rawType = response.headers['content-type'];
        const type = typeof rawType === 'string' ? rawType : undefined;
        const blob = new Blob([response.data], { type });
        FileSaver.saveAs(blob, filename);
    } catch (error) {
        console.log('error: ', error);
    }
}
